var map = {
	"./prism-coy.css": 38,
	"./prism-dark.css": 39,
	"./prism-funky.css": 40,
	"./prism-okaidia.css": 41,
	"./prism-solarizedlight.css": 42,
	"./prism-tomorrow.css": 43,
	"./prism-twilight.css": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;